<template>
  <div id="container">
    <el-row>
      <el-col :span="7" style="padding-right:20px">
        <div class="item-box-content" style="height:276px;">
          <div class="title-font-style">
            <span>客户信息</span>
          </div>
          <div class="customer_name" @click="onCusName">{{customerVo.cusName}}</div>
          <div class="customer_grade">
            <el-rate
              v-model="starLevel"
              disabled
              show-score
              text-color="#ff9900"
              score-template="{value}星"
            ></el-rate>
            <span>（系数{{customerVo.starPoint*100}}%）</span>
          </div>
          <el-row>
            <el-col :span="12">客户编号：{{customerVo.cusCode}}</el-col>
            <el-col :span="12">法人姓名：{{customerVo.cusElp}}</el-col>
          </el-row>
          <div style="margin-top:42px">
            <div class="custom-money-num">￥{{customerVo.balance|priceFilterNum}}</div>
            <div class="custom-money-info">账户余额</div>
          </div>
        </div>
      </el-col>
      <el-col :span="17" class="item-box-content" style="position: relative">
        <el-col :span="12">
          <el-echart
            ref="echartRefs"
            :echartId="contractAmountId"
            :style="styleEchart"
            :options="conOption"
          ></el-echart>
        </el-col>
        <!-- <el-button @click="onTransfer(initalBalance, 1)">划拨期初应收款</el-button> -->
        <el-button
          @click="onTransfer(initalBalance, 1)"
          class="posi"
          :disabled="initalBalance<1"
        >划拨期初应收款</el-button>
        <el-col :span="12">
          <!-- <div style="position: relative;top: 15%;"> -->
          <el-echart :echartId="receivablesId" :style="styleEchart" :options="reOption"></el-echart>
          <!-- </div> -->
          <!-- <div style="text-align:right; position: relative;top: 15%;">
          </div>-->
        </el-col>
      </el-col>
    </el-row>
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item,index) in transferEditTabs"
          :label="item.title"
          :name="item.name"
          class="tab-text"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
      <!-------------- 待划拨合同 -------------->
      <div class="box-table" v-show="activeName==='待划拨合同'">
        <el-table
          border
          ref="tableRef"
          :data="list"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          max-height="378"
          element-loading-spinner="el-icon-loading"
         >
          <el-table-column prop="contractType" label="合同类型" show-overflow-tooltip></el-table-column>
          <el-table-column label="合同编号" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="approval" @click="onContractCode(scope.row)">{{scope.row.contractCode}}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户合同编号" width="110" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.customerContractCode||'--'}}</template>
          </el-table-column>
          <el-table-column label="客户名称" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="approval line-limit-length" @click="onCusName">{{scope.row.customerName}}</div>
            </template>
          </el-table-column>
          <el-table-column label="付款类型" prop="payType"></el-table-column>
          <el-table-column label="合同金额">
            <template slot-scope="scope">{{scope.row.contractTotal|priceFilterNum}}</template>
          </el-table-column>
          <el-table-column label="合同状态" prop="signState"></el-table-column>
          <el-table-column label="发货状态">
            <template
              slot-scope="scope"
            >{{scope.row.deliverState===1?'部分发货':scope.row.deliverState===2?'全部发货':'未发货'}}</template>
          </el-table-column>
          <el-table-column label="已收账款">
            <template slot-scope="scope">{{scope.row.accountsReceived|priceFilterNum}}</template>
          </el-table-column>
          <el-table-column label="应收账款">
            <template slot-scope="scope">{{scope.row.accountsCollect|priceFilterNum}}</template>
          </el-table-column>
          <el-table-column label="已到期账款" width="110">
            <template slot-scope="scope">{{scope.row.accountsDue|priceFilterNum}}</template>
          </el-table-column>
          <el-table-column label="开票状态">
            <template
              slot-scope="scope"
            >{{scope.row.state===1?'部分开票':scope.row.state===2?'全部开票':'未开票'}}</template>
          </el-table-column>
          <el-table-column prop="afterSale" label="售后记录"></el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="onTransfer(scope.row, 2)">划拨</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination" v-show="activeName==='待划拨合同'">
        <pagination
          :currentPage="currentPage"
          :pageSize="pageSize"
          :total="total"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>

      <!-------------- 待划拨工单 -------------->
      <div class="box-table" v-show="activeName==='待划拨工单'">
        <el-table
          border
          ref="tableRef"
          :data="waitList"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          max-height="378"
          element-loading-spinner="el-icon-loading"
         >
          <el-table-column label="工单类型" prop="orderType" show-overflow-tooltip></el-table-column>
          <el-table-column label="工单编号" prop="orderNumber" show-overflow-tooltip></el-table-column>
          <el-table-column label="客户名称" prop="cusName" show-overflow-tooltip></el-table-column>
          <el-table-column label="付款类型" prop="payType" show-overflow-tooltip></el-table-column>
          <el-table-column label="工单总额" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.orderMoney|priceFilterNum}}</template>
          </el-table-column>
          <el-table-column label="已收金额" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.amountReceived|priceFilterNum}}</template>
          </el-table-column>
          <el-table-column label="应收金额" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.amountReceivable|priceFilterNum}}</template>
          </el-table-column>
          <el-table-column label="开票状态" show-overflow-tooltip>
            <template v-slot="{row}">{{row.invoiceState===1?'未开票':row.invoiceState===2?'开票审核':'已开票'}}</template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="onTransfer(scope.row, 3)">划拨</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination" v-show="activeName==='待划拨工单'">
        <pagination
          :currentPage="currentPage"
          :pageSize="pageSize"
          :total="total1"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
    <!---------------- 划拨 -------------->
    <return-money-transfer-dialog ref="returnMoneyTransferDialogRefs" @onRefresh="onRefresh"></return-money-transfer-dialog>
  </div>
</template>
<script>
import echart from '@/components/echart/index'
import returnMoneyTransferDialog from '../../dialog/returnMoneyTransferDialog'
import { transferEditTabs } from '../../util/data'
import {
  queryTransFlowByCusId,
  queryCustomerMsgByCusId,
  workOrderWithTransfer
} from '@/api/sell/sellManage'
import pagination from '@/components/pagination'
export default {
  components: {
    'el-echart': echart,
    'return-money-transfer-dialog': returnMoneyTransferDialog,
    pagination: pagination
  },
  data() {
    return {
      starLevel: 0,
      total: 0,
      total1: 0,
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      customerVo: {}, // 客户信息
      initalBalance: 0, // 划拨 期初应收款
      loadingTable: false,
      list: [], // 待划拨合同列表
      waitList: [], // 待划拨工单列表
      transferEditTabs,
      activeName: '待划拨合同',
      contractAmountId: 'contractAmountId', // 已收账款ID
      styleEchart: {
        height: '276px'
      },
      // type: 1, // 期初划拨弹窗
      conOption: {
        // 已收账款数据
        title: {
          text: '贸易额',
          textStyle: {
            color: '#4E555B',
            fontWeight: '500',
            fontSize: '16'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter(params) {
            let content
            if (params.seriesName !== '中间文字') {
              // content = `${params.seriesName}<br/>${params.marker}${params.name}：${params.value}`
              content = `${params.marker}${params.name}：${params.value}`
            }
            return content
          }
        },
        series: [
          {
            name: '贸易额',
            type: 'pie',
            center: ['40%', '50%'],
            radius: ['50%', '65%'],
            startAngle: 0,
            label: {
              show: true,
              fontSize: 12,
              formatter: ['{a|{c}}', '{hr|}', '{b|{b}}'].join('\n'),
              rich: {
                a: {
                  color: '#4E555B'
                },
                hr: {
                  height: 4
                },
                b: {
                  color: '#4E555B'
                }
              }
            },
            data: [
              { value: 0, name: '已收账款' },
              { value: 0, name: '应收账款' }
            ],
            itemStyle: {
              color({ dataIndex }) {
                if (dataIndex === 0) {
                  return '#5AA5FF'
                }
                if (dataIndex === 1) {
                  return '#62CF83'
                }
              }
            }
          },
          {
            name: '中间文字',
            type: 'pie',
            hoverOffset: 0,
            center: ['40%', '50%'],
            radius: ['50%', '50%'],
            label: {
              show: true,
              position: 'center',
              formatter: ['{a|{c}}', '{b|{b}}'].join('\n'),
              rich: {
                a: {
                  color: '#4E555B',
                  fontSize: 18
                },
                b: {
                  fontSize: 14,
                  color: '#4E555B'
                }
              }
            },
            data: [{ name: '贸易额', value: 0 }],
            itemStyle: {
              color: '#fff'
            }
          }
        ]
      },
      receivablesId: 'receivablesId', // 已收账款ID
      reOption: {
        // 已收账款数据
        title: {
          text: '应收账款',
          textStyle: {
            color: '#4E555B',
            fontWeight: '500',
            fontSize: '16'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter(params) {
            let content
            if (params.seriesName !== '中间文字') {
              // content = `${params.seriesName}<br/>${params.marker}${params.name}：${params.value}`
              content = `${params.marker}${params.name}：${params.value}`
            }
            return content
          }
        },
        series: [
          {
            name: '应收账款',
            type: 'pie',
            center: ['40%', '50%'],
            radius: ['50%', '65%'],
            startAngle: 0,
            label: {
              show: true,
              fontSize: 12,
              formatter: ['{a|{c}}', '{hr|}', '{b|{b}}'].join('\n'),
              rich: {
                a: {
                  color: '#4E555B'
                },
                hr: {
                  height: 4
                },
                b: {
                  color: '#4E555B'
                }
              }
            },
            data: [
              { value: 0, name: '期初应收账款' },
              { value: 0, name: '已到期账款' }
            ],
            itemStyle: {
              color({ dataIndex }) {
                if (dataIndex === 0) {
                  return '#F8D95B'
                }
                if (dataIndex === 1) {
                  return '#5AA5FF'
                }
                //   return colorList.yellow
              }
            }
          },
          {
            name: '中间文字',
            type: 'pie',
            center: ['40%', '50%'],
            radius: ['50%', '50%'],
            hoverOffset: 0,
            label: {
              show: true,
              position: 'center',
              formatter: ['{a|{c}}', '{b|{b}}'].join('\n'),
              rich: {
                a: {
                  fontSize: 18,
                  color: '#4E555B'
                },
                b: {
                  fontSize: 14,
                  color: '#4E555B'
                }
              }
            },
            data: [{ name: '应收账款', value: 0 }],
            itemStyle: {
              color: '#fff'
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.getList()
    this.tableList()
  },
  methods: {
    onRefresh(num) {
      if (num === 2) {
        this.tableList()
      }
      this.getList()
    },
    onContractCode(row) {
      if (row.signState === '履行中' || row.signState === '已履行') {
        this.$router.push({
          name: 'contractEdit',
          query: { id: row.contractId, cusId: this.$route.query.id }
        }) // 合同详情(已签订合同)
      } else {
        this.$router.push({
          name: 'contractCreate',
          query: { id: row.contractId }
        }) // 合同详情(未签订合同)
      }
    },
    onCusName() {
      this.$router.push({
        name: 'customer/details',
        query: { id: this.$route.query.id }
      })
    },
    handleClick(tab) {
      this.currentPage = 1
      this.pageSize = 30
      this.activeName = tab.name
      this.tableList()
    },
    tableList() {
      if (this.activeName === '待划拨合同') {
        queryCustomerMsgByCusId(
          this.$route.query.id,
          this.currentPage,
          this.pageSize
        ).then((res) => {
          if (res.data.code === 200) {
            this.total = res.data.obj.total
            this.list = res.data.obj.records
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        workOrderWithTransfer(
          this.$route.query.id,
          this.currentPage,
          this.pageSize
        ).then((res) => {
          if (res.data.code === 200) {
            this.total1 = res.data.obj.total
            this.waitList = res.data.obj.records
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    // 获取详情数据
    getList() {
      queryTransFlowByCusId(this.$route.query.id).then((res) => {
        if (res.data.code === 200) {
          this.customerVo = res.data.obj.customerAccountCreditVo
          const obj = res.data.obj.customerAccountCreditVo.customerAccountBase
          this.$set(this.customerVo, 'balance', obj.accountBalance)
          this.initalBalance = obj.initalBalance
          this.conOption.series[0].data[0].value =
            (+obj.paymentReceived).toFixed(2) || 0.0 // 已收账款
          this.conOption.series[0].data[1].value =
            (+obj.accountsReceivable).toFixed(2) || 0.0 // 应收账款
          this.conOption.series[1].data[0].value =
            (+this.customerVo.money).toFixed(2) || 0.0 // 贸易额
          this.reOption.series[0].data[0].value =
            (+obj.initalBalance).toFixed(2) || 0.0 // 期初应收账款
          this.reOption.series[0].data[1].value =
            (+obj.accountsDue).toFixed(2) || 0.0 // 已到期账款
          this.reOption.series[1].data[0].value =
            (+obj.accountsReceivable).toFixed(2) || 0.0 // 应收账款
          this.starLevel = this.customerVo.starLevel
            ? parseInt(this.customerVo.starLevel.split('星')[0])
            : 1
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 页数
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.tableList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.tableList()
    },
    // 划拨
    onTransfer(val, type) {
      this.$refs.returnMoneyTransferDialogRefs.onInitial(val, type)
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
.customer_name {
  font-weight: 500;
  color: #276cff;
  font-size: 18px;
  margin: 30px 0 12px;
  box-sizing: border-box;
}
.customer_grade {
  display: flex;
  font-size: 14px;
  color: #83878a;
  align-items: center;
  padding-bottom: 30px;
}
.posi {
  position: absolute;
  top: 16px;
  right: 20px;
  z-index: 9;
}
.custom-money-num {
  font-size: 18px;
  font-family: HelveticaNeue;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
  line-height: 30px;
}
.custom-money-info {
  font-size: 14px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: rgba(131, 135, 138, 1);
  line-height: 22px;
}
</style>
